export const getTokenFromStorage = (): string => {
	if (sessionStorage.getItem('session') != null) {
		const email = sessionStorage.getItem('session') as string;
		return JSON.parse(email).token as string;
	} else {
		return '';
	}
};